import { Component } from '@angular/core';
import { IonicPage, NavController, NavParams, AlertController } from 'ionic-angular';
import { TranslateService } from '@ngx-translate/core';

import { Quiz } from "../../models/quiz.model";

import { QuizProvider } from "../../providers/quiz/quiz";
import { LanguageProvider } from '../../providers/language/language';

import { QuizDetailPage } from "../quiz-detail/quiz-detail";
import { LoginPage } from '../auth/login';

import { fadeInOutAnimation } from '../../animations/fade-in-out';

@IonicPage()
@Component({
  selector: 'page-quizzes',
  templateUrl: 'quizzes.html',
  animations: [
    fadeInOutAnimation
  ]
})
export class QuizzesPage {

  quizzes: Quiz[];
  loading: boolean;

  dateLocale: string;

  constructor(public navCtrl: NavController, public navParams: NavParams, public translate: TranslateService, public languageProvider: LanguageProvider, public alertCtrl: AlertController, public quizProvider: QuizProvider) {
    this.dateLocale = this.languageProvider.getByLocale(this.translate.currentLang).code;
  }

  getQuizzes() {
    this.loading = true;
    this.quizProvider.getAll()
      .subscribe(
        quizzes => this.quizzes = quizzes,
        error => {
          if (error.status == 401) {
            this.disconnected();
          }
          this.loading = false;
        },
        () => {
          this.loading = false;
        }
      );
  }

  reloadQuizzes(refresher) {
    this.quizProvider.getAll()
      .subscribe(
        quizzes => this.quizzes = quizzes,
        error => {
          if (error.status == 401) {
            this.disconnected();
          }
          refresher.complete();
        },
        () => {
          refresher.complete();
        }
      );
  }

  openDetail(quiz) {
    if (quiz.user_quiz_created) {
      let alert = this.alertCtrl.create({
        title: this.translate.instant('MODAL_ERROR_TITLE'),
        subTitle: this.translate.instant('MODAL_ERROR_QUIZ_ALREADY_ANSWERED'),
        buttons: [
          this.translate.instant('BTN_OK')
        ]
      });
      alert.present();
    } else {
      this.navCtrl.push(QuizDetailPage, {
        id: quiz.id
      });
    }
  }

  disconnected() {
    this.navCtrl.setRoot(LoginPage, {
      disconnected: true
    });
  }

  ionViewDidLoad() {
    this.getQuizzes();
  }

}



// WEBPACK FOOTER //
// ./src/pages/quizzes/quizzes.ts